/**
 * @file Web Galleries Route Component.
 */

import { renderRoutes } from 'react-router-config';

import routes from './routes';

const WebGalleriesMasterRoute = () => renderRoutes(routes);

export default WebGalleriesMasterRoute;
